import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

import { Router } from '@angular/router';
import { MemberService } from './../../member/member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { MemberPipe } from './../../shared/search.member';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { GroupService } from './../group.service';
import { UISETTING } from './../../shared/ui-setting';
import { BaseGroup } from './../base-group';
@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.css'],
  providers: [MemberService, MessageEvent, SignInEvent, AppService, OpenFrameEvent, LoaderEvent, GroupService, HiddenFooter, SetAllMemberCheck]
})
export class CreateGroupComponent extends BaseGroup implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private divHeight = 30;
  private pagebutton = 30;
  private noMemberAvailable: boolean = true;
  private groupObj = {
    name: '',
    description: '',
    members: [],
    createdBy: '',
    vendor: '',
    activities: ''
  };
  private selectMember = false;
  private disableMembers = '';
  private exp = false;
  private disableSelectMember = false;
  private membersInGroup = [];
  @ViewChild('memberTable')
  tableVariable: any;
  private totalSizeOfList = 0;
  private onePagePerItem = 10; // It will set by vendor configuration object
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  private createGroupView = false;
  private groupFilter = [];
  private memberTableHeight = 65;
  private setChecked = [];
  private showFilterGroup = false;
  private noMemberAvailableInFilter = false;
  private openSubMenu1 = false;
  private openSubMenu2 = false;
  private openSubMenu3 = false;
  private uiSetting: UISETTING;
  private height: any
  private filterSendInvite = false;
  private sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  constructor(private router: Router, private memberService: MemberService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private hiddenFooter: HiddenFooter,
    private signInEvent: SignInEvent, private loaderEvent: LoaderEvent, private groupService: GroupService, private setAllMemberCheck: SetAllMemberCheck) {
    super();
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 10
    }
    this.height = 0;
    this.popUpMessage = 'Is Payment Done';
    this.hideEdit = false;
    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
    this.selectMember = false;
    this.groupObj.name = '';
    this.groupObj.members = [];
  }

  ngOnInit() {
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.clubName = this.vendor.clubName;
    this.getFacilityListForFilter(this);
    let vendorObj = { vendorId: this.vendor._id };
    this.appService.getListOfGroup(vendorObj).then((data: any) => {
      if (data.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.groupList = data.groups;
      }
    });
    this.pagination(this.pageOptions, 1);
    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
  }

  /**
   * Temproray function
   */

  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }

  redirectToGroup() {
    this.memberTableHeight = 0;
    if (this.groupList.length > 0) {
      this.router.navigate(['/group']);
    } else {
      this.router.navigate(['/managegroup']);
    }
  }

  /**
   * Retrive MemberList with respect to condo
   */

  getMemberListByGroup(request) {
    try {
      this.loaderEvent.fire(false);
      let that = this;
      this.appService.getListOfMember(request).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.memberList = result.memberList;
          this.totalSizeOfList = result.total;
          this.noMemberAvailable = (result.total > 0);
          if (this.memberList.length === 0) {
            this.noMemberAvailable = false;
          } else {
            this.memberList.map(function (rec: any) {
              rec.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(rec.signedUpOn).format('DD/MM/YYYY');
              if (rec.hasLeftService) {
                rec.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(rec.leftServiceDate).format('DD/MM/YYYY');
              }
              return rec;
            });
            this.noMemberAvailable = true;
            this.setCheckedList();
          }
          if (request['filters'].length > 0) {
            this.noMemberAvailableInFilter = true;
          } else {
            this.noMemberAvailableInFilter = false;
          }
          this.loaderEvent.fire(true);
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * TO change status of member if payment is done
   */

  onNotify(message: boolean): void {
    let email = atob(localStorage.getItem('member_email'));
    this.memberList.map(function (mem) {
      if (mem.emailId === email) {
      }
      return mem;
    });
  }

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }

  /*
  * create group with name and member list
  */

  insertMemberInGroup(obj: any, popUpObj) {
    try {
      if (obj.sendDataFlag) {
        this.groupObj.vendor = this.vendor._id;
        this.groupObj.createdBy = this.vendor._id;
        this.groupObj.activities = obj.activities;
        if (this.groupObj.name) {
          this.groupService.createGroup(this.groupObj).then((result: any) => {
            if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
              this.loaderEvent.fire(true);
              localStorage.setItem('recentCreatedGroupId', btoa(JSON.stringify(result.groupId)));
              this.router.navigate(['/group']);
            } else {
              this.popUpMessage = result.message;
              popUpObj.showChildModal();
            }
          }).catch((err) => {
            this.popUpMessage = err;
            this.loaderEvent.fire(true);
          });
        } else {
          this.popUpMessage = CONSTANT_MESSAGES.GROUP_NAME_EMPTY_ERROR_MSG;
          popUpObj.showChildModal();
          return;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  /*
   * all members will unselect if group name is blank.
   */

  unCheckAllMembersForGroupName() {
    try {
      if (!this.groupObj.name) {
        this.selectMember = false;
        //  this.disableSelectMember = false;
        this.createGroupView = false;
        this.groupObj.members = this.memberList.filter(function (rec: any) {
          if (rec.isChecked) {
            rec.isChecked = false;
            return rec;
          }
        });
        if (this.tableVariable.allInGroup) {
          this.tableVariable.allInGroup = false;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  /*
   * all members will unselect if description name is blank.
   */
  unCheckAllMembersForDescription() {
    try {
      if (!this.groupObj.description) {
        this.selectMember = false;
        // this.disableSelectMember = false;
        this.createGroupView = false;
        this.groupObj.members = this.memberList.filter(function (rec: any) {
          if (rec.isChecked) {
            rec.isChecked = false;
            return rec;
          }
        });
        if (this.tableVariable.allInGroup) {
          this.tableVariable.allInGroup = false;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  /*
   * function for expand search input tag
   */
  expand() {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1);
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.pagination(this.pageOptions, 1);
      }
      this.exp = !this.exp;
    }
  }

  disableSelectMemberOnCheck(bool: boolean) {
    if (!this.disableSelectMember) {
      this.disableSelectMember = bool;
    }
  }

  /*
   * function will call on every check box
   */

  createMemberListForGroup(memberList: any) {
    this.setChecked = this.setChecked.concat(memberList);
    this.groupObj.members = this.setChecked;
    this.disableSelectMember = true;
    if (!this.tableVariable.allInGroup) {
      this.groupObj.members = [];
      this.setChecked = _.difference(this.setChecked, memberList);
    }
  }

  /*
   * Add member to make group
   */
  addMemberInGroupList(memberObj: any) {
    if (memberObj.isChecked) {
      this.groupObj.members.push(memberObj.userId);
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.groupObj.members, function (n) {
        return n === memberObj.userId;
      });
      _.remove(this.setChecked, function (n) {
        return n === memberObj.userId;
      });
      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    }
    if (this.groupObj.members.length === 0) {
      this.tableVariable.allInGroup = false;
    }
  }

  /*
   * Confirmation popup to make new group
   */
  confirmForCreateGroup(popUpObjConfirm, popUpObj) {
    if (this.groupObj.members.length === 0) {
      this.popUpMessage = CONSTANT_MESSAGES.ADD_MEMBER_GROUP;
      popUpObj.showChildModal(1);
      return;
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.CONFIRMATION_CREATE_GROUP;
      popUpObjConfirm.showChildModal();
    }

  }

  /*
   * Pagination is done on no of items in one page and current page
   */
  pagination(pageOptions, pageNo) {
    this.filterState = this.filterPara;
    if (pageOptions) {
      this.pageOptions = pageOptions;
    }
    let requestObject = this.setVendorIdAsPerRole(pageNo);
    this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
    this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED;

    switch (this.filterPara) {
      case 'Inactive':
        requestObject['filters'].push({
          type: 'isDeactivated',
          values: true
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'DisabledFacility':
        requestObject['filters'].push({
          type: 'disabled',
          values: this.facilityFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Prefernces':
        requestObject['filters'].push({
          type: 'facilityPreference',
          values: this.preferenceFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Groups':
        requestObject['filters'].push({
          type: 'group',
          values: this.groupFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'SentInvite':
        if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
          requestObject['filters'].push({
            type: 'isInviteSent',
            values: true
          });
        }
        if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
          requestObject['filters'].push({
            type: 'isInviteSent',
            values: false
          });
        }
        if (this.inviteStatusFilter.length == 0) {
          requestObject['filters'] = [];
        }
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
    }
    if ((this.searchMember + '').trim()) {
      requestObject['filters'].push({
        type: 'search',
        values: this.searchMember
      });
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
    }
    this.getMemberListByGroup(requestObject);
  }

  /*
   * Insert facility to apply disable facility filter
   */

  addFacilityForFilter(e, facilityId) {
    this.utilityFunctions.addFacilityForFilter(this, e, facilityId);
  }

  /*
   * Select category for filter
   */
  setFilterCriteria(para) {
    this.utilityFunctions.setFilterCriteria(this, para);
  }

  /*
   * Insert group to apply filter
   */
  addGroupForFilter(e, groupId) {
    this.utilityFunctions.addGroupForFilter(this, e, groupId);
  }

  /*
   * Insert facility to apply preference filter
   */
  addPreferencesForFilter(e, facilityId) {
    this.utilityFunctions.addPreferencesForFilter(this, e, facilityId);
  }

  addInviteStatusForFilter(e, status) {
    this.utilityFunctions.addInviteStatusForFilter(this, e, status);
  }
  /*
   * Redirect ot addmember page
   */
  redirectToAddMember() {
    this.router.navigate(['/addmember']);
  }

  /*
   * Store checked list on any pages of member list
   */
  setCheckedList() {
    try {
      let flagAllChecked = true;
      for (let rec of this.setChecked) {
        for (let mem of this.memberList) {
          if (rec === mem.userId) {
            mem.isChecked = true;
            break;
          }
        }
      }
      for (let mem of this.memberList) {
        if (!mem.isChecked) {
          flagAllChecked = false;
          break;
        }
      }
      if (flagAllChecked) {
        this.tableVariable.allInGroup = true;
      } else {
        this.tableVariable.allInGroup = false;
      }
    } catch (e) {
      console.log(e);
    }
  }

  /*
   * Maintain state of filter
   */
  maintainFilterState() {
    this.utilityFunctions.maintainFilterState(this);
  }

  setVendorIdAsPerRole(pageNo) {
    let requestObject = {
      'vendorId': '',
      perPage: this.pageOptions.noOfPageItem,
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    if (this.vendor.role === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      requestObject['vendorId'] = this.vendor._id;
    } else if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      let subVendor = this.vendor.subVendors[0];
      requestObject = {
        'vendorId': subVendor._id,
        perPage: this.pageOptions.noOfPageItem,
        pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
        filters: []
      };
    }

    return requestObject;
  }
}



// WEBPACK FOOTER //
// ./src/app/group/create-group/create-group.component.ts